import React, { Fragment } from 'react';
import "./list.css";
import {getMatchWords} from "./getMatchWords";


const List = (
  {
    data,
    word,
    setSelectedText,
    showContextMenu
  }
) => {
  return (
    <Fragment>
      {
        !data.length ?
          <span style={{alignSelf: 'center'}}>No data</span>
          :
        data.map((d, i) => {
            console.log(d.split(" "));
          console.log(getMatchWords({ word, text: d}), '---------------------------')

          return (
            <div
              key={i}
              className="list_item"
              dangerouslySetInnerHTML={{__html: getMatchWords({ word, text: d})}}
              onContextMenu={e => {
                e.preventDefault();
                e.stopPropagation();
                setSelectedText();
                showContextMenu({top: e.clientY, left: e.clientX})
              }}
            />
          )
        })
      }
    </Fragment>
  )
};

export default List;


// WEBPACK FOOTER //
// ./src/components/list/list-component.js